// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { transition } from '../styles';
export var actionsBarClassName = 'media-card-actions-bar';
export var fixedActionBarStyles = "opacity: 1;";
export var wrapperStyles = function wrapperStyles(isFixed) {
  return (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    css(isFixed ? fixedActionBarStyles : 'opacity: 0;', transition(), {
      position: 'absolute',
      top: 0,
      right: 0,
      display: 'flex',
      flexFlow: 'row nowrap',
      justifyContent: 'right',
      padding: "var(--ds-space-100, 8px)",
      gap: "var(--ds-space-100, 8px)"
    })
  );
};
wrapperStyles.displayName = 'ActionsBarWrapper';